import Link from "next/link";
import React from "react";
import { useAnalytics } from "~/components/Analytics";
import { socialMediaShareStyles } from "~/components/SocialMediaShareMenu/shared-social-media-share-styles";
import { Body } from "~/ui-library";

export type SocialMediaShareButtonProps = {
  label: string;
  href: string;
  icon: JSX.Element;
};

type SocialMediaShareButtons = {
  Large: React.FC<SocialMediaShareButtonProps>;
  Small: React.FC<SocialMediaShareButtonProps>;
};

const Small = React.forwardRef<HTMLAnchorElement, SocialMediaShareButtonProps>(
  ({ href, label, icon }, ref) => {
    const { analyticsEnhancedTrack } = useAnalytics();
    return (
      <Link
        className={socialMediaShareStyles({ size: "small" })}
        href={href}
        onClick={() => {
          analyticsEnhancedTrack("Content: Social Share", {
            shareMethod: label,
          });
        }}
        ref={ref}
        target="_blank"
      >
        {icon}
        <Body bold size="small">
          {label}
        </Body>
        <div />
      </Link>
    );
  }
);

Small.displayName = "SocialMediaShareSmallButton";

const Large = React.forwardRef<HTMLAnchorElement, SocialMediaShareButtonProps>(
  ({ href, label, icon }, ref) => {
    const { analyticsEnhancedTrack } = useAnalytics();

    return (
      <Link
        className={socialMediaShareStyles({ size: "large" })}
        href={href}
        onClick={() => {
          analyticsEnhancedTrack("Content: Social Share", {
            shareMethod: label,
          });
        }}
        ref={ref}
        target="_blank"
      >
        {icon}
        <Body bold size="default">
          {label}
        </Body>
        <div />
      </Link>
    );
  }
);

Large.displayName = "SocialMediaShareLargeButton";

export const SocialMediaShareButton: SocialMediaShareButtons = {
  Small,
  Large,
};
